import React, { useEffect, useState } from 'react';

export const FilterContext = React.createContext();

export const FilterProvider = ({ children }) => {
    const [ searchString, setSearchString ] = useState('');
    const [ classFilter, setClassFilter ] = useState(null);
    const [ schoolFilter, setSchoolFilter ] = useState(null);
    const [ saveFilter, setSaveFilter ] = useState(null);
    const [ levelFilter, setLevelFilter ] = useState([]);
    const [ sourceFilter, setSourceFilter ] = useState([]);
    const [ damageTypeFilter, setDamageTypeFilter ] = useState([]);
    const [ componentFilter, setComponentFilter ] = useState({positive: [], negative: []});
    const [ tagFilter, setTagFilter ] = useState({positive: [], negative: []});
    const [ attackFilter, setAttackFilter ] = useState(null);
    const [ castingTimeFilter, setCastingTimeFilter ] = useState(null);
    const [ activeCount, setActiveCount ] = useState(0);

    const filters = {
        class: classFilter,
        school: schoolFilter,
        save: saveFilter,
        level: levelFilter,
        source: sourceFilter,
        damageType: damageTypeFilter,
        component: componentFilter,
        tag: tagFilter,
        attack: attackFilter,
        castingTime: castingTimeFilter,
    };

    const setFilters = (nextFilters = {}) => {
        setClassFilter(nextFilters.class ?? null);
        setSchoolFilter(nextFilters.school ?? null);
        setSaveFilter(nextFilters.save ?? null);
        setAttackFilter(nextFilters.attack ?? null);
        setCastingTimeFilter(nextFilters.castingTime ?? null);
        setLevelFilter(nextFilters.level ?? []);
        setSourceFilter(nextFilters.source ?? []);
        setDamageTypeFilter(nextFilters.damageType ?? []);
        setComponentFilter(nextFilters.component ?? { positive: [], negative: [] });
        setTagFilter(nextFilters.tag ?? { positive: [], negative: [] });
    };

    useEffect(() => {
        setActiveCount(
            (!!classFilter ? 1 : 0)
             + (!!schoolFilter ? 1 : 0)
             + (!!saveFilter ? 1 : 0)
             + (!!attackFilter ? 1 : 0)
             + (!!castingTimeFilter ? 1 : 0)
             + (levelFilter.length)
             + (sourceFilter.length)
             + (damageTypeFilter.length)
             + (componentFilter?.positive.length)
             + (componentFilter?.negative.length)
             + (tagFilter?.positive.length)
             + (tagFilter?.negative.length)
        );
    }, [attackFilter, classFilter, schoolFilter, saveFilter, levelFilter, sourceFilter, componentFilter, tagFilter, damageTypeFilter, castingTimeFilter]);

    const clearFilters = () => {
        setFilters({});
        setActiveCount(0);
    };

    return (
        <FilterContext.Provider value={{ 
            searchString, setSearchString,
            classFilter, setClassFilter, 
            saveFilter, setSaveFilter,
            schoolFilter, setSchoolFilter, 
            levelFilter, setLevelFilter,
            sourceFilter, setSourceFilter,
            componentFilter, setComponentFilter,
            tagFilter, setTagFilter,
            damageTypeFilter, setDamageTypeFilter,
            attackFilter, setAttackFilter,
            castingTimeFilter, setCastingTimeFilter,
            filters,
            setFilters,
            activeCount, clearFilters
         }}>
             {children}
        </FilterContext.Provider>
    );
};
